export function formatNumber(value, digits = 2) {
  if (value === null || value === undefined) return 'N/A';
  return Number(value).toFixed(digits);
}

export function formatPercent(value) {
  if (value === null || value === undefined) return 'N/A';
  return `${(Number(value) * 100).toFixed(1)}%`;
}
